
export function saveStoreCache(state, cache) {
    state._cache_ = cache;
}
